import React, { useEffect, useState } from 'react';
import {Modal, Button } from 'react-bootstrap';
import Box from '@material-ui/core/Box';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { guardarTema, showForm } from '../../../actions/cursosActions';
import { useParams } from 'react-router-dom';
import { string } from 'prop-types';


const NuevoTema = () => {
  const params = useParams();
  const { idCapacitacion } = params;
  const show = useSelector(state => state.foro.show_formulario);
  const usuario = useSelector(state=> state.usuario.usuario);
  const idMatricula = useSelector(state => state.cursos.idMatricula);



  const dispatch = useDispatch();
  const initialState = {
    titulo_tema:'',
    descripcion_tema:'',
    id_proyecto:idCapacitacion,
    id_estudiante: usuario ? usuario.id_usuario : null
  }
  const [datosTema,setDatosTema]=useState(initialState)

  const {titulo_tema, descripcion_tema} = datosTema

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDatosTema({
      ...datosTema,
      [evt.target.name]: value
    });
  }
  const enviarTema = async (e) => {
  e.preventDefault();

  dispatch(guardarTema({
    ...datosTema,
    id_matricula: idMatricula
  }));

  setDatosTema(initialState);
  dispatch(showForm());
};


  return (
    <>
    <Button variant="primary" size="lg" className="float-right" onClick={() => dispatch(showForm())}>
     Proponer Tema
    </Button>

    <Modal
      show={show}
      onHide={() => dispatch(showForm())}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          Nuevo Tema
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <form onSubmit={(e) => enviarTema(e)}>
      <Box component="fieldset" mb={3} borderColor="transparent">
            <label>Título del Tema</label>
            <input type="text" className="form-control" name="titulo_tema" value={titulo_tema} onChange={handleChange}/>
          </Box>
          <Box component="fieldset" mb={3} borderColor="transparent">
            <label>Descripción del Tema</label>
            <textarea name="descripcion_tema" className="form-control" value={descripcion_tema} onChange={handleChange} />
          </Box>
          <Box component="fieldset" mb={3} borderColor="transparent" >          
          <button type="reset" className="btn btn-danger" onClick={() => dispatch(showForm())}>
           Cancelar
          </button>
          &nbsp;
          <button type="submit" className="btn btn-primary btn-submit mr-2" >
            Publicar Tema
          </button>
          </Box>
      </form>
      </Modal.Body>
    </Modal>
  </>
   );
}
 
export default NuevoTema;